<template>
    <v-dialog v-model="dialog" width="1280px" max-width="85%">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" text> 수정 </v-btn>
        </template>
        <v-card>
            <v-card-title class="py-2 px-4 py-md-3 px-md-5 text-md-16 grey lighten-2">
                답변수정
                <v-spacer />
                <v-icon @click="dialog = false"> mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="py-2 px-4 py-md-3 px-md-5">
                <v-row class="row--small">
                    <v-col cols="12" md="10">
                        <v-textarea v-model="content" placeholder="답변을 입력하세요." outlined hide-details dense />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-row class="row--small ma-n1 ma-md-0 h-100">
                            <v-col cols="6" md="12">
                                <v-file-btn block outlined color="gray-9" @input="pushFile" class="h-100 h-md-36">첨부</v-file-btn>
                            </v-col>
                            <v-col cols="6" md="12">
                                <v-btn block color="primary" @click="save" class="h-100 h-md-36">수정</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <div class="mt-5" v-if="files.length">
                    <v-chip-group v-model="files" multiple column>
                        <v-chip outlined v-for="file in files" :key="file.name" :value="file">{{ file.name }}<v-icon small>mdi-close</v-icon></v-chip>
                    </v-chip-group>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import vFileBtn from "@/components/plugins/vuetify/v-file-btn.vue";
export default {
    components: { vFileBtn },
    props: ["value", "response"],
    data() {
        return {
            dialog: false,
            content: this.response?.content || "",
            files: [],
        };
    },
    methods: {
        pushFile(file) {
            const fileNames = this.files.map(({ name }) => name.split("/").pop());
            if (!fileNames.includes(file.name)) this.files.push(file);
            else alert("동일한 이름의 파일이 있습니다.");
        },
        async save() {
            try {
                let {
                    response: { _id, _files = [] },
                    content,
                    files,
                    value,
                } = this;

                for (const _id of _files) {
                    await api.v1.counsels.files.delete({ _id });
                }

                const { counselResponse } = await api.v1.counsels.responses.put({ _id, content });

                files = await Promise.all(files.map(async (file) => (await api.v1.counsels.files.post({ _request: counselResponse._request, _response: counselResponse._id }, file)).file));

                counselResponse.files = files;
                counselResponse._files = files.map(({ _id }) => _id);

                const responses = [...value.responses];
                const index = responses.findIndex(({ _id }) => _id == counselResponse._id);
                Object.assignDefined(responses[index], counselResponse);
                this.$emit("input", {
                    ...value,
                    responses,
                });
                alert("수정되었습니다.");
                this.dialog = false;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        async dialog() {
            if (this.dialog) {
                this.content = this.response.content;
                this.files = await Promise.all(this.response.files.map(async ({ url }) => await api.getResource(url)));
            }
        },
    },
};
</script>

<style></style>
